import { Variant } from '../types/product';
import { RegExpMatchArrayWithGroups } from '../types/WigWizard';

export function getSkuObject(selectedVariant: Variant) {
  const groupsArray = selectedVariant.sku.split("-");
  let groups
  if (groupsArray.length===6){
       groups={Type: groupsArray[0]+"-"+groupsArray[1], Product:groupsArray[2], Color:groupsArray[3]+"-"+groupsArray[4], Length:groupsArray[5] }
    }  else{
      groups={Type: groupsArray[0]+"-"+groupsArray[1], Product:groupsArray[2], Color:groupsArray[3], Length:groupsArray[4]}

  }

  // Allow for non-conforming lengths
  const acceptedLengths = [10, 12, 14, 18, 20, 24, 30];
  const lengthInt = parseInt(groups.Length, 10);

  if (acceptedLengths.indexOf(lengthInt) === -1) {
    const indexArr = acceptedLengths.map((num) => {
      return Math.abs(num - lengthInt);
    });
    const min = Math.min(...indexArr)
    const closest = acceptedLengths[indexArr.indexOf(min)];
    groups.Length = closest.toString();
  }

  // const { groups } = /(?<Type>.{9,10})-(?<Product>[^-]+)-(?<Color>.{3,5}(?:-[A-Z]{2,5})?)-(?<Length>\d\d)/mg.exec(selectedVariant.sku) as RegExpMatchArrayWithGroups;
  if (selectedVariant.sku.includes('STR-613')) // Hack for this pattern-breaking SKU
    groups.Product = 'STR-613';
  return groups;

}
